import React, { useEffect } from "react";
import styles from "../DevelopmentFinanceBlogs/DevelopmentFinanceBlogs.module.scss";
import Footer from "../../components/Footer";
import { useParams } from "react-router-dom";
import NewsContainer from "../../components/NewsContainer";
import CompareContainerC4 from "../../components/CompareContainer/CompareContainerC4";
import MatchingMortgagesC4 from "../../components/MatchingMortgages/MatchingMortgagesC4";
import LoanApplicationC4 from "../../components/LoanApplication/LoanApplicationC4";
import HeroSection from "../../components/HeroSection/HeroSection";
import TestimonialsContainer from "../../components/TestimonialsContainer";
// import TypeOfRequirements from "../../components/TypeOfRequirements";
import CallAdviser from "../../components/CallAdviser";

const CaseStudies4 = () => {
  const { blogId } = useParams();
  console.log(blogId);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.developmentFinanceBlogs}>
      <HeroSection title="Resources" />
      <CompareContainerC4 title="Resources" />
      {/* <TypeOfRequirements title="Resources" /> */}
      <CallAdviser title="Resources" />
      <MatchingMortgagesC4 title="Resources" />
      <NewsContainer title="Resources" />
      <LoanApplicationC4 title="Resources" />
      <TestimonialsContainer title="Resources" />
      <Footer title="Resources" />
    </div>
  );
};

export default CaseStudies4;
